module.exports = __webpack_public_path__ + "static/media/intro_image.e779ca2c.svg";